import { render, staticRenderFns } from "./sky-input-sendMsg.vue?vue&type=template&id=32e34986&scoped=true"
import script from "./sky-input-sendMsg.vue?vue&type=script&lang=js"
export * from "./sky-input-sendMsg.vue?vue&type=script&lang=js"
import style0 from "./sky-input-sendMsg.vue?vue&type=style&index=0&id=32e34986&prod&lang=scss&scoped=true"
import style1 from "./sky-input-sendMsg.vue?vue&type=style&index=1&id=32e34986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e34986",
  null
  
)

export default component.exports